<template>
  <el-container style="background:#E6E6E6;min-height:100%">
    <el-header>
      <img src="../../assets/img/layout/logo.png" alt />
      <h1>浙江省学校体育协会运动员注册与报名系统</h1>
      <div class="info">
        <span class="user_name">欢迎你~{{userInfo.name}}</span>
        <span class="login_out" @click="out">退出登录</span>
      </div>
    </el-header>
    <el-container>
      <el-aside width="280px">
        <div class="user_info">
          <img class="head_img" src="../../assets/img/layout/user.png" alt />
          <section>
            <p v-if="schoolName" class="school_name">{{schoolName}}</p>
            <p>{{userRole}}</p>
          </section>
        </div>
        <leftMenu></leftMenu>
      </el-aside>
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
import { loginOut } from "@/api/login";
import { clearSession, getSession } from "@/utils/storage";
import leftMenu from "./components/left-menu";
export default {
  components: {
    leftMenu
  },
  data() {
    return {
      userInfo: {},
      schoolName: JSON.parse(getSession("userInfo")).schoolName || ""
    };
  },
  computed: {
    windowHeigth() {
      return document.body.clientHeight;
    },
    userRole() {
      return this.userInfo.name;
    }
  },
  watch: {
    "$store.state.userInfo": {
      deep: true,
      handler(value) {
        if (value) this.userInfo = value;
      }
    }
  },
  methods: {
    // 退出登录
    out() {
      loginOut({}).then(res => {
        clearSession("userInfo");
        this.$router.replace("/login");
        location.reload();
      });
    },
    // 获取用户信息
    getUserInfo() {
      this.userInfo = this.$store.state.userInfo || null;
    }
  },
  mounted() {
    const _body = document.querySelector("body");
    _body.style.overflowY = "hidden";
    this.getUserInfo();
  }
};
</script>
<style lang="less" scoped>
</style>
<style lang='less'>
.el-header {
  width: 100%;
  background-color: #1e63b0;
  color: #fff;
  height: 100px !important;
  display: flex;
  align-items: center;
  margin-bottom: 6px;
  position: fixed;
  > img {
    margin: 0 20px;
  }
  > h1 {
    font-size: 28px;
    color: #fff;
    font-weight: 600;
    flex: 1;
  }
  > .info {
    display: flex;
    align-items: center;
    color: #fff;
    > .user_name {
      margin-right: 40px;
    }
    > .login_out {
      width: 80px;
      line-height: 32px;
      text-align: center;
      border: 1px solid #fff;
      border-radius: 2px;
      cursor: pointer;
    }
  }
}
.el-aside {
  background: #fff;
  height: 100%;
  position: fixed;
  top: 100px;
  z-index: 200;
  padding-bottom: 100px;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.5);
  .user_info {
    padding: 20px 10px 0 20px;
    margin-bottom: 40px;
    display: flex;
    align-items: center;
    .head_img {
      width: 80px;
      height: 80px;
      border-radius: 50%;
      margin-right: 10px;
    }
    .school_name {
      margin-bottom: 25px;
    }
  }
}
.el-main {
  background: #fff;
  padding: 34px!important;
  margin: 106px 0 0 290px;
  height: calc(100vh - 106px);
  overflow-y: scroll;
}
</style>